import './selector-result-count.css';

import h from 'hyperscript';

import { assert } from 'cadenza/utils/custom-error';
import { formatNumber } from 'cadenza/utils/format/format';

import i18n from './messages.properties';

const name = 'd-selector-result-count';

export class SelectorResultCount extends HTMLElement {

  #loadingContainer;
  #resultCountContainer;
  #resultsI18nKey;

  constructor (resultsI18nKey = 'results') {
    super();
    this.#resultsI18nKey = resultsI18nKey;
  }

  connectedCallback () {
    this.classList.add(name);

    this.#loadingContainer = h('d-progress-spinner.d-progress-spinner-xs', { label: i18n('updateResults') });
    this.#loadingContainer.style.display = 'none';

    this.#resultCountContainer = h('div.d-selector-result-count--container');

    this.append(this.#loadingContainer, this.#resultCountContainer);

    const resultCount = this.hasAttribute('unique-result-count') ? Number(this.getAttribute('result-count')) : -1;
    const uniqueResultCount = this.hasAttribute('unique-result-count') ? Number(this.getAttribute('unique-result-count')) : -1;
    this.setValues(resultCount, uniqueResultCount);
  }

  setValues (resultCount, uniqueResultCount) {
    assert(Number.isFinite(resultCount), 'resultCount must be finite');
    assert(Number.isFinite(uniqueResultCount), 'uniqueResultCount must be finite');

    this.hideLoading();

    let resultCountText = i18n(this.#resultsI18nKey, {
      count: resultCount,
      resultCount: formatNumber(resultCount)
    });
    if (uniqueResultCount > 0 && resultCount !== uniqueResultCount) {
      resultCountText = i18n('objects', { count: uniqueResultCount, objectCount: formatNumber(uniqueResultCount) }) + ' ' + resultCountText;
    }

    this.#resultCountContainer.textContent = resultCountText;
    this.#resultCountContainer.hidden = resultCount < 0;
  }

  setLoading () {
    this.#loadingContainer.style.display = 'flex';
    this.#resultCountContainer.hidden = true;
  }

  hideLoading () {
    this.#loadingContainer.style.display = 'none';
  }

}

customElements.define(name, SelectorResultCount);
